import { Chip, Grid, Typography } from "@mui/material";
import { memo, useCallback, useEffect, useState } from "react";

type Option = {
  name: string;
  value: string;
};

type Props = {
  options: Array<Option>;
  onChange: (primary: string, list?: Array<Option>) => void;
  initialPrimary: string;
};

const RecruiterSelector = ({ options, onChange, initialPrimary }: Props) => {
  const [primary, setPrimary] = useState(initialPrimary || "");

  useEffect(() => {
    if (!initialPrimary && options.length) {
      setPrimary(options[0].value);
      onChange(options[0].value);
    }
  }, [options, onChange, initialPrimary]);

  const onPrimary = useCallback(
    (value: string) => {
      setPrimary(value);
      onChange(value, options);
    },
    [onChange, options],
  );

  const onDelete = useCallback(
    (value) => {
      const newList = options.filter((el) => el.value !== value);
      if (newList.length) {
        if (value === primary) {
          onChange(newList[0].value, newList);
        } else {
          onChange(primary, newList);
        }
      } else {
        onChange("", []);
      }
    },
    [onChange, options, primary],
  );
  return (
    <Grid container gap={2} my={1}>
      {options.filter(Boolean).map((recruiter) => {
        return (
          <RecruiterChip
            label={recruiter.name}
            key={recruiter.value}
            onPrimary={onPrimary}
            onDelete={onDelete}
            value={recruiter.value}
            primary={primary}
          />
        );
      })}
    </Grid>
  );
};

type RecruiterChipProps = {
  label: string;
  onPrimary: (value: string) => void;
  onDelete: (value: string) => void;
  value: string;
  primary: string;
};

const RecruiterChip = ({
  label,
  onDelete,
  onPrimary,
  value,
  primary,
}: RecruiterChipProps) => {
  const onDeleteCallback = useCallback(() => {
    onDelete(value);
  }, [onDelete, value]);
  const onClickCallback = useCallback(() => {
    onPrimary(value);
  }, [onPrimary, value]);
  return (
    <Chip
      color="primary"
      label={
        <Grid container gap={1}>
          {label}
          <Typography variant="button" fontSize={10}>
            {primary === value ? "Primary" : "Make Primary"}
          </Typography>
        </Grid>
      }
      variant={primary === value ? "filled" : "outlined"}
      onDelete={onDeleteCallback}
      onClick={onClickCallback}
    ></Chip>
  );
};

export default memo(RecruiterSelector);
